import React from 'react';
import { Row, Col, Input, message } from 'antd';

const { Search } = Input;

function ResourcesFinderHeader(props) {
  const { handleSearch } = props;

  return (
    <Row style={{ marginTop: -35 }} type="flex">
      <Col span={12}>
        <p
          style={{
            float: 'left',
            fontSize: '26px',
            fontWeight: 500,
            color: 'black',
            marginLeft: '25px',
          }}
        >
          {'Resources Finder'}
        </p>
      </Col>

      <Col span={12}>
        <Search
          onChange={e => {
            if (!e.target.value)
              handleSearch(
                {
                  type: 'search',
                  value: e.target.value,
                },
                'resourceDrawer'
              );
          }}
          onSearch={value => {
            if (!value) {
              message.error('Input field is empty');
              return;
            }

            let extraFilteration = {
              type: 'search',
              value: [value],
            };
            handleSearch(extraFilteration, 'resourceDrawer');
          }}
          placeholder="Search resources"
          style={{ width: 250, float: 'right', marginRight: '25px' }}
        />
      </Col>
    </Row>
  );
}

export default ResourcesFinderHeader;
